import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  open: false,
  title: undefined,
  message: '',
  param: undefined,
  confirmFunction: null,
}

export const dialogSlice = createSlice({
  name: 'base/dialog',
  initialState,
  reducers: {
    openDialogAction: (state, { payload: { message, title, param, confirmFunction } }) => {
      {
        return {
          ...state,
          open: true,
          title: title,
          message: message,
          param: param,
          confirmFunction: confirmFunction
        }
      }
    },
    closeDialogActoin: (state) => {
      {
        return {
          ...state,
          open: false,
          title: undefined,
          message: '',
          confirmFunction: null
        }
      }
    },
    confirmDialogActoin: (state, { payload: { param } }) => {
      return {
        ...state,
        param: param
      }
    },
  },
})

export const { openDialogAction, closeDialogActoin, confirmDialogActoin } = dialogSlice.actions

export default dialogSlice.reducer
